import React, { useEffect } from 'react';
import {APP_PREFIX_PATH} from "../../../configs/AppConfig";
import {useHistory} from "react-router-dom";
import {ArrowLeftOutlined} from "@ant-design/icons";
import {DIR_RTL} from "../../../constants/ThemeConstant";
import {useSelector} from "react-redux";

function OrderModeStatic({mode}) {
    const history = useHistory()
    const {theme:{direction}, fetchedData:{storeData}} = useSelector(state => state)

    const pushPath = (path = '/') => {
        history.push(APP_PREFIX_PATH.concat(path))
    }

    useEffect(()=>{
        window.scrollTo({top:0, behavior: 'auto'});
    }, [])

    return (
        <>
            <div className="mt-2 py-2 border-bottom">
                <h3 className='order-mode__prev border-0 text-center'>
                    Order Mode
                    <ArrowLeftOutlined onClick={() => {window.history.back();localStorage.removeItem('location')}} rotate={direction === DIR_RTL ? 180 : 0}/>
                </h3>
            </div>
            <div className='d-flex text-center border-bottom px-3'>
                {storeData?.showDeliveryText && <div
                    onClick={() => pushPath('/order-mode?mode=delivery')}
                    className={`${mode === 'delivery' && 'active'} menu-tab__item ${!(storeData?.showPickupText) && 'menu-tab__item_single'}`}
                >
                    Delivery
                </div>}
                {storeData?.showPickupText && <div
                    onClick={() => pushPath('/order-mode?mode=pickup')}
                    className={`${mode === 'pickup' && 'active'} menu-tab__item ${!(storeData?.showDeliveryText) && 'menu-tab__item_single'}`}
                > 
                    Pickup
                </div>}
            </div>
        </>
    );
}

export default OrderModeStatic;